import { CHANNEL_ID_BASE } from '../../config';
import { toJSNumber } from '../numbers';

export function isUserId(entityId: string) {
  // Coerce before the string check: post-bigint-migration some callers pass a number/bigint id
  // at runtime (despite the string type), and `.startsWith` only exists on strings. The sibling
  // helpers below already tolerate this via `BigInt(entityId)`.
  return !String(entityId).startsWith('-');
}

export function isChannelId(entityId: string) {
  const n = BigInt(entityId);
  return n < -CHANNEL_ID_BASE;
}

export function toChannelId(mtpId: string) {
  const n = BigInt(mtpId);
  return String(-CHANNEL_ID_BASE - n);
}

export function getRawPeerId(id: string) {
  const n = BigInt(id);
  if (isUserId(id)) {
    return n;
  }

  if (isChannelId(id)) {
    return -n - CHANNEL_ID_BASE;
  }

  return n * -1n;
}

export function getPeerIdDividend(peerId: string) {
  return toJSNumber(getRawPeerId(peerId));
}
